import React from 'react';
import Input, { InputProps } from '@gik/ui/Input';
import SvgIcon from '@gik/ui/SvgIcon';
import bemBlock from '@gik/core/utils/bemBlock';

export interface InkindSearchProps extends InputProps {}

function InkindSearch(
  { className, ...otherProps }: InkindSearchProps,
  ref: React.Ref<HTMLInputElement>
): React.ReactElement {
  const bem = bemBlock('input-search');

  return (
    <form className={bem('form')} method="post" action="/search/inkind">
      <Input
        className={bem(null, null, className)}
        ref={ref}
        name="query"
        variant="primary"
        size="sm"
        placeholder="Search"
        prepend={<SvgIcon name="Search" />}
        append={
          <button className={bem('search-button')} type="submit">
            <SvgIcon name="ArrowRight" size="sm" />
          </button>
        }
        {...otherProps}
      />
    </form>
  );
}

export default React.forwardRef(InkindSearch);
